import { BRANDING, CATEGORY_DECK } from "@/branding";

// Build a slug -> name map from the brand deck so UI labels stay in sync with branding.js
export const CATEGORY_LABELS = CATEGORY_DECK.reduce((acc, c) => {
  acc[c.slug] = c.name;
  return acc;
}, { "general": "General" });

export const formatPrice = (n, currency = "USD") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: currency.toUpperCase() }).format(Number(n) || 0);

export const resolveImage = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return `${base}${url}`;
};

export const STORE_FULL_NAME = `${BRANDING.storeName}${BRANDING.storeNameAccent ? " " + BRANDING.storeNameAccent : ""}`;
